<template>
  <!-- <div> -->
  <v-dialog v-if="definitionList" v-model="dialog" max-width="500" scrollable>
    <template v-slot:activator="{ on, attrs }">
      <v-btn x-small v-bind="attrs" v-on="on" class="" color="#FFF">
        <v-icon color="primary" class="mr-1" x-small>mdi-book-alphabet</v-icon
        >Definitions
      </v-btn>
    </template>
    <v-card>
      <div class="orangeCardTitle title pa-3">{{ title }}</div>
      <v-card-text class="darkerCardText py-4">
        <div v-for="def in definitionList" :key="def">
          <div v-if="definitions && definitions[def]" class="">
            <!--  :class="i % 2 == 0 ? 'shady' : null" -->
            <div
              class="font-weight-bold defTitle px-1 mb-1"
              v-html="definitions[def].name"
            ></div>
            <vue-markdown class="ml-2">{{
              definitions[def].definition
            }}</vue-markdown>
            <!-- <div v-html="definitions[def].definition"></div> -->
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!-- </div> -->
</template>

<script>
// import Name from "../dir/file";
import VueMarkdown from "@adapttive/vue-markdown";

export default {
  name: "DefinitionListDialog",
  components: { VueMarkdown },
  props: {
    title: {
      type: String,
      default: "Definitions",
    },
    // an array of wanted definition keys
    definitionList: {
      default: function () {
        return [];
      },
    },
    // an object of definitions with structure {
    // "key": { "name": "xxx", "definition": "xxx"},
    definitions: null,
  },
  data: function () {
    return { dialog: false };
  },
  methods: {},
  computed: {},
};
</script>

<style scoped>
.defTitle {
  background-color: #e8f5ff;
}
</style>
